export const ROUTES = {
	CORE: '/',
	PROFILE: '/profile',
};
